import { render, staticRenderFns } from "./BuyerAnalyticsDataTable.vue?vue&type=template&id=4d7b03f8&scoped=true&"
import script from "./BuyerAnalyticsDataTable.vue?vue&type=script&lang=ts&"
export * from "./BuyerAnalyticsDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./BuyerAnalyticsDataTable.vue?vue&type=style&index=0&id=4d7b03f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7b03f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VBtn,VCheckbox,VChip})
